/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbExternalEhrDocument } from './HchbExternalEhrDocument';
import {
    HchbExternalEhrDocumentFromJSON,
    HchbExternalEhrDocumentFromJSONTyped,
    HchbExternalEhrDocumentToJSON,
    HchbExternalEhrDocumentToJSONTyped,
} from './HchbExternalEhrDocument';

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    processing_error?: string;
    /**
     * 
     * @type {HchbExternalEhrDocument}
     * @memberof Document
     */
    external_ehr_document?: HchbExternalEhrDocument;
}

/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): value is Document {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'processing_error': json['processing_error'] == null ? undefined : json['processing_error'],
        'external_ehr_document': json['external_ehr_document'] == null ? undefined : HchbExternalEhrDocumentFromJSON(json['external_ehr_document']),
    };
}

export function DocumentToJSON(json: any): Document {
    return DocumentToJSONTyped(json, false);
}

export function DocumentToJSONTyped(value?: Document | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        's3_key': value['s3_key'],
        'processing_error': value['processing_error'],
        'external_ehr_document': HchbExternalEhrDocumentToJSON(value['external_ehr_document']),
    };
}

